import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacypolicy',
  templateUrl: './privacypolicy.component.html',
  styleUrls: ['./privacypolicy.component.scss']
})
export class PrivacypolicyComponent implements OnInit {
  private isgraybackground:boolean=false;
  constructor() { }

  ngOnInit() {
    if(localStorage.getItem("PrimaryColor") && localStorage.getItem("SecondaryColor"))
    {
      //this.isFromDns=localStorage.getItem("isfromDns")
      this.isgraybackground=true;
    }
  }

}
